import { render, staticRenderFns } from "./PageListSlider.vue?vue&type=template&id=34e9e24a"
import script from "./PageListSlider.vue?vue&type=script&lang=js"
export * from "./PageListSlider.vue?vue&type=script&lang=js"
import style0 from "./PageListSlider.vue?vue&type=style&index=0&id=34e9e24a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports